export const PROCESS_HEALTH_COMPANY_ID = 79905
export const PROCESS_HEALTH_ROUTE = '/report/process-health'
export const PROCESS_HEALTH_PATH = '/app/report/process-health'
export const PDF_FAILED_MESSAGE = 'Could not create the PDF'
export const EMPTY_MONTHS_MESSAGE =
    'No completed Process Health Check audits yet.'

export const getUserCompanyId = user =>
    Number(
        user?.CompanyId ??
            user?.companyId ??
            user?.Companies?.[0]?.CompanyId ??
            0,
    )

/**
 * Login capability is the switch. The API sets it only for company 79905.
 * Missing or false hides the menu (sessions from before the release too).
 * A known company id other than 79905 is hidden even if the flag is present.
 */
export const canViewProcessHealthReport = user => {
    if (user?.Capabilities?.ShowProcessHealthReport !== true) return false
    const companyId = getUserCompanyId(user)
    if (companyId && companyId !== PROCESS_HEALTH_COMPANY_ID) return false
    return true
}
